import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";
import InfoIcon from "@rip/icons/info.svg";
import "./FormBlocks.scss";
const { sanitize } = dompurify;
export const InputLabel = ({ label, htmlFor, id, required }) => {
    return (_jsx("label", { htmlFor: htmlFor, id: id, "data-testid": "input-label", className: "aem-text-input__label", dangerouslySetInnerHTML: {
            __html: sanitize(`${label} ${required ? "*" : ""}`),
        } }));
};
export const InputFooter = ({ message, disclaimer, displayError }) => {
    const textContent = displayError ? message : disclaimer;
    if (!textContent) {
        return null;
    }
    return (_jsxs("div", { className: classNames("aem-contact-form__disclaimer", {
            "aem-contact-form__disclaimer--error": displayError,
        }), children: [_jsx("div", { className: "aem-contact-form__disclaimer-icon", children: _jsx("span", { className: "icon__wrapper", children: _jsx(InfoIcon, {}) }) }), _jsx("div", { "data-testid": "input-message", className: "aem-contact-form__disclaimer-text", children: textContent })] }));
};
//# sourceMappingURL=FormBlocks.js.map